'use client';

import { useEffect } from 'react';

export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  useEffect(() => {
    console.error('App error:', error);
  }, [error]);

  return (
    <main className="min-h-screen flex flex-col items-center justify-center text-center px-4 py-12 bg-white text-blue-900">
      <h1 className="text-4xl font-bold mb-4">Something went wrong</h1>
      <p className="mb-6 text-lg">We encountered an unexpected error. Please try again.</p>
      <button
        onClick={() => reset()}
        className="px-4 py-2 bg-amber-500 text-white rounded hover:bg-amber-600 transition"
      >
        Try Again
      </button>
    </main>
  );
}
